<template>
  <base-modal ref="modal" @hiding="reset">
    <base-card shadow>
      <div class="sm:tw-flex sm:tw-items-start">
        <div
          class="tw-flex tw-flex-shrink-0 tw-mx-auto tw-justify-center tw-items-center tw-bg-primary-50 tw-w-12 tw-h-12 tw-rounded-full sm:tw-mx-0 sm:tw-h-10 sm:tw-w-10 sm:tw-my-auto"
        >
          <arrow-renew-icon class="tw-w-5 tw-h-5 tw-text-primary-500" />
        </div>
        <div class="sm:tw-flex-col sm:tw-items-start sm:tw-ml-2 sm:tw-justify-start tw-mt-3 sm:tw-mt-0 tw-text-center sm:tw-text-left">
          <div class="tw-font-thin tw-text-xl">Recharge Plan: {{ plan.planName }}</div>
          <div class="tw-text-gray-600 tw-font-light">How many credits?</div>
        </div>
      </div>
      <div class="tw-flex tw-justify-center tw-mt-6 tw-gap-6">
        <base-icon class="tw-my-auto tw-bg-primary-50" color="primary" @click="subtract"> <minus-icon class="tw-h-6 tw-w-6"/></base-icon>
        <base-text-field type="number" class="tw-text-center tw-w-24" v-model="rechargeCount" />
        <base-icon class="tw-my-auto tw-bg-primary-50" color="primary" @click="add"> <plus-icon class="tw-h-6 tw-w-6"/></base-icon>
      </div>
      <inline-error class="tw-mt-3" id="recharge-credits-modal-error" :title="errorTitle" :message="errorMessage" :error="error" />
      <div class="sm:tw-flex sm:tw-flex-row-reverse tw-mt-6">
        <base-button @click="rechargeCredits" :disabled="rechargeCount <= 0" :loading="isLoading" class="tw-w-full sm:tw-w-auto sm:tw-ml-3">
          Recharge {{ rechargeCount }} {{ rechargeCount == 1 ? "credit" : "credits" }} for {{ chargePriceFormatted }}
        </base-button>
        <base-button @click="hide" type="flat" color="gray" class="tw-w-full sm:tw-w-auto tw-mt-2 sm:tw-mt-0">
          Cancel
        </base-button>
      </div>
    </base-card>
  </base-modal>
</template>

<script>
import { MinusIcon, PlusIcon, ArrowRenewIcon } from "@/assets/svgs";
import InlineError from "@/components/InlineError";

export default {
  name: "CreditRecharge",
  components: { MinusIcon, PlusIcon, ArrowRenewIcon, InlineError },
  props: {
    businessId: String,
    userId: String,
    plan: Object,
  },
  data() {
    return {
      isLoading: false,
      rechargeCount: 1,
      errorTitle: "",
      errorMessage: "",
      error: null,
    };
  },
  computed: {
    locale() {
      return window.navigator.language;
    },
    chargePriceFormatted() {
      return this.plan.creditUnitPrice
        ? new Intl.NumberFormat(this.locale, { style: "currency", currency: this.plan.currency }).format((this.plan.creditUnitPrice * this.rechargeCount) / 100)
        : "";
    },
  },
  methods: {
    show() {
      this.$refs.modal.show();
    },
    hide() {
      this.$refs.modal.hide();
    },
    add() {
      this.rechargeCount++;
    },
    subtract() {
      if (this.rechargeCount === 0) return;
      this.rechargeCount--;
    },
    reset() {
      this.rechargeCount = 1;
      this.errorTitle = "";
      this.errorMessage = "";
      this.error = null;
    },
    async rechargeCredits() {
      try {
        this.isLoading = true;

        const response = await this.$axios.post(`/businesses/${this.businessId}/members/${this.userId}/plans/${this.plan.userBusinessPlanId}/recharge`, {
          quantity: this.rechargeCount,
        });

        if (response.data.chargeStatus === "succeeded") {
          this.EventBus.$emit("GLOBAL_NOTIFY", { title: "Plan Recharged", message: "You successfully recharged " + this.rechargeCount + " credits" });
          this.EventBus.$emit("member_update");
          this.EventBus.$emit("refresh");
          this.hide();
        } else {
          this.errorTitle = "Charge " + response.data.chargeStatus;
          this.errorMessage = "The charge " + response.data.chargeStatus + " with the seller message: " + response.data.sellerMessage;
          this.error = {};
        }
      } catch (error) {
        this.errorTitle = "Error recharging plan ";
        this.errorMessage = "We were not able to recharge your credits. There may have been a connection error. Please reload the page to try again.";
        this.error = error;
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>
